import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AddOn } from 'anchor-shared/lib/model/entity/addOn';

@Component({
  selector: 'app-optional-add-ons-list-dialog',
  templateUrl: './optional-add-ons-list-dialog.component.html',
})
export class OptionalAddOnsListDialogComponent {
  addOns: AddOn[];
  optionalAddOns: AddOn[];

  constructor(
    private dialogRef: MatDialogRef<OptionalAddOnsListDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
  ) {
    this.addOns = this.data.addOns;
    this.optionalAddOns = this.data.addOns.filter((x) => !x?.required);
  }
}
